import { GraphData, PercentageMetrics } from '../lib/types'

export const data: GraphData = {
	"products": [
		{
			"Name": "GlobusBeyond Architect",
			"Description": "",
			"Revenue": "6"
		},
		{
			"Name": "GlobusBeyond Operating Model",
			"Description": "",
			"Revenue": "1"
		},
		{
			"Name": "GlobusBeyond Process Miner",
			"Description": "",
			"Revenue": "24"
		},
		{
			"Name": "GlobusBeyond GRC",
			"Description": "",
			"Revenue": "26"
		}
	],
	"stages": [
		{
			"Name": "Discovery",
			"Description": "Identifying & Engaging Potential Customers",
			"Percentage": 33,
			"PercentageMetrics": new PercentageMetrics(30, 83, 46, 20, 51, 81, true, true, false, true, false, false, false)
		},
		{
			"Name": "Validation",
			"Description": "Assessing Fit & Qualification",
			"Percentage": 85,
			"PercentageMetrics": new PercentageMetrics(78, 84, 39, 87, 21, 18, true, true, true, true, true, false, true)
		},
		{
			"Name": "Technology",
			"Description": "Product Fit & Proof of Value",
			"Percentage": 41,
			"PercentageMetrics": new PercentageMetrics(48, 74, 37, 76, 77, 84, true, false, true, false, true, true, false)
		},
		{
			"Name": "Pricing",
			"Description": "Commercial Structuring",
			"Percentage": 53,
			"PercentageMetrics": new PercentageMetrics(59, 57, 53, 83, 39, 39, true, false, false, false, false, true, false)
		},
		{
			"Name": "Negotiation",
			"Description": "Terms Finalisation & Objection Handling",
			"Percentage": 61,
			"PercentageMetrics": new PercentageMetrics(32, 91, 86, 85, 13, 46, true, true, true, true, true, false, true)
		},
		{
			"Name": "Procurement",
			"Description": "Approval & Compliance Process",
			"Percentage": 78,
			"PercentageMetrics": new PercentageMetrics(62, 77, 24, 54, 46, 88, true, false, true, true, true, true, true)
		},
		{
			"Name": "PO Received",
			"Description": "Operational Readiness",
			"Percentage": 27,
			"PercentageMetrics": new PercentageMetrics(84, 79, 28, 42, 81, 25, true, false, true, true, false, true, false)
		},
		{
			"Name": "Closed Won",
			"Description": "Customer Onboarding & Value Realisation",
			"Percentage": 24,
			"PercentageMetrics": new PercentageMetrics(71, 48, 88, 19, 66, 52, true, true, false, false, true, true, false)
		}
	],
	"capabilities": [
		{
			"Name": "Contract & SLA Management",
			"Stage": "Negotiation",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_cb9f2be7-6786-4094-a4cc-89fa24e15659_KEYRESULT_Lift_renewal_rate_to_92_per_cent",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_speed%20contract%20approvals"
			]
		},
		{
			"Name": "Objection Handling & Competitive Analysis",
			"Stage": "Negotiation",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_improve%20objection%20handling"
			]
		},
		{
			"Name": "Order Processing & Billing Setup",
			"Stage": "PO Received",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_lift%20billing%20activation%20rate",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_speed%20invoicing"
			]
		},
		{
			"Name": "Product Demonstration & Proof of Concept (PoC)",
			"Stage": "Technology",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_cb9f2be7-6786-4094-a4cc-89fa24e15659_KEYRESULT_Lift_POC_win_rate_to_35_per_cent"
			]
		},
		{
			"Name": "Compliance & Risk Assessment",
			"Stage": "Procurement",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_reduce%20high-risk%20deals",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_cb9f2be7-6786-4094-a4cc-89fa24e15659_KEYRESULT_Achieve_100_per_cent_risk_assessment_completion"
			]
		},
		{
			"Name": "Procurement Process Navigation",
			"Stage": "Procurement",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_speed%20vendor%20onboarding",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_speed%20procurement%20approvals"
			]
		},
		{
			"Name": "Customer Success Handover",
			"Stage": "Closed Won",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_lift%20onboarding%20completion",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_lift%20onboarding%20readiness",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_lift%20satisfaction"
			]
		},
		{
			"Name": "Upsell & Expansion Strategy",
			"Stage": "Closed Won",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_lift%20upsell%20conversion",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_lift%20cross-sell%20success",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_grow%20expansion%20arr"
			]
		},
		{
			"Name": "Market Intelligence & Lead Generation",
			"Stage": "Discovery",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_9efa3c2e-92a7-40b8-9b60-5cc1c6e17071_KEYRESULT_Grow_qualified_lead_volume_to_1500",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_9efa3c2e-92a7-40b8-9b60-5cc1c6e17071_KEYRESULT_Lift_LQS_to_75",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_9efa3c2e-92a7-40b8-9b60-5cc1c6e17071_KEYRESULT_Reduce_CPL_to_120",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_9efa3c2e-92a7-40b8-9b60-5cc1c6e17071_KEYRESULT_Lift_engagement_rate_to_35_per_cent"
			]
		},
		{
			"Name": "Deal Structuring & Pricing Optimisation",
			"Stage": "Pricing",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_keep%20avg%20discounts%20under%20control",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_cb9f2be7-6786-4094-a4cc-89fa24e15659_KEYRESULT_Reduce_discount_approvals_to_15_per_cent"
			]
		},
		{
			"Name": "ROI & Business Case Modelling",
			"Stage": "Pricing",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_KEYRESULT_improve%20roi%20justification"
			]
		},
		{
			"Name": "Lead Qualification & Scoring",
			"Stage": "Validation",
			"Description": "",
			"AssessedBy": [
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_9efa3c2e-92a7-40b8-9b60-5cc1c6e17071_KEYRESULT_Lower_disqualification_rate_to_12_per_cent",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_9efa3c2e-92a7-40b8-9b60-5cc1c6e17071_KEYRESULT_Lift_SQL_conversion_to_25_per_cent",
				"http://orbus_busarch.capsi.com.au/orbus_busarch/SP/Model#DATAIMPORT_9efa3c2e-92a7-40b8-9b60-5cc1c6e17071_KEYRESULT_Speed_deal_velocity_to_30_days"
			]
		}
	],
	"applicationGroups": [
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC Account Executives",
			"Capability": "Contract & SLA Management",
			"Stage": "Negotiation",
			"Percentage": new PercentageMetrics(51, 11, 75, 55, 89, 55, true, true, false, true, true, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA Account Executives",
			"Capability": "Contract & SLA Management",
			"Stage": "Negotiation",
			"Percentage": new PercentageMetrics(15, 94, 35, 80, 64, 13, true, false, false, true, false, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER Account Executives",
			"Capability": "Contract & SLA Management",
			"Stage": "Negotiation",
			"Percentage": new PercentageMetrics(33, 52, 41, 39, 61, 21, true, false, false, true, true, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Stage": "Negotiation",
			"Percentage": new PercentageMetrics(25, 68, 28, 54, 15, 81, true, true, true, true, false, false, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Stage": "Negotiation",
			"Percentage": new PercentageMetrics(68, 11, 16, 87, 59, 49, true, false, true, false, false, false, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Stage": "Negotiation",
			"Percentage": new PercentageMetrics(71, 37, 91, 82, 33, 42, true, true, true, false, true, false, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Stage": "PO Received",
			"Percentage": new PercentageMetrics(44, 31, 19, 47, 75, 54, true, true, true, false, false, false, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Stage": "PO Received",
			"Percentage": new PercentageMetrics(59, 77, 25, 72, 45, 25, true, false, true, true, false, true, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Stage": "PO Received",
			"Percentage": new PercentageMetrics(32, 24, 69, 15, 48, 65, true, true, true, false, false, false, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Stage": "Technology",
			"Percentage": new PercentageMetrics(84, 86, 23, 84, 51, 31, true, false, false, false, false, true, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Stage": "Technology",
			"Percentage": new PercentageMetrics(12, 11, 42, 84, 14, 54, true, false, false, true, true, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Stage": "Technology",
			"Percentage": new PercentageMetrics(23, 53, 67, 15, 84, 37, true, false, false, true, true, true, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Stage": "Technology",
			"Percentage": new PercentageMetrics(91, 50, 36, 31, 12, 73, true, true, false, false, false, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Stage": "Technology",
			"Percentage": new PercentageMetrics(47, 74, 86, 57, 64, 26, true, false, true, false, true, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Stage": "Technology",
			"Percentage": new PercentageMetrics(92, 34, 95, 14, 48, 28, true, false, false, false, false, true, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC Legal",
			"Capability": "Procurement Process Navigation",
			"Stage": "Procurement",
			"Percentage": new PercentageMetrics(30, 10, 52, 31, 26, 66, true, false, true, true, false, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA Legal",
			"Capability": "Procurement Process Navigation",
			"Stage": "Procurement",
			"Percentage": new PercentageMetrics(80, 80, 85, 88, 11, 53, true, false, false, false, false, false, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER Legal",
			"Capability": "Procurement Process Navigation",
			"Stage": "Procurement",
			"Percentage": new PercentageMetrics(64, 56, 66, 20, 59, 83, true, false, false, false, false, false, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER CSMs",
			"Capability": "Customer Success Handover",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(15, 10, 57, 33, 42, 25, true, false, true, false, true, false, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC CSMs",
			"Capability": "Customer Success Handover",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(11, 44, 47, 26, 83, 44, true, true, true, false, true, false, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA CSMs",
			"Capability": "Customer Success Handover",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(93, 88, 91, 69, 40, 69, true, false, false, true, false, false, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(82, 53, 51, 23, 75, 40, true, false, false, false, false, true, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(55, 26, 18, 93, 81, 77, true, true, false, false, true, true, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(76, 66, 74, 58, 21, 44, true, true, true, false, true, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Stage": "Discovery",
			"Percentage": new PercentageMetrics(94, 92, 23, 80, 14, 94, true, false, false, true, false, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Stage": "Discovery",
			"Percentage": new PercentageMetrics(89, 16, 12, 15, 25, 23, true, true, false, false, true, false, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Stage": "Discovery",
			"Percentage": new PercentageMetrics(74, 29, 18, 73, 22, 62, true, true, true, false, false, true, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(90, 26, 86, 46, 60, 93, true, false, false, true, false, true, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(68, 77, 53, 38, 15, 28, true, false, false, false, true, true, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(20, 25, 67, 14, 93, 91, true, false, false, true, true, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(38, 10, 71, 86, 81, 66, true, true, true, true, true, true, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(60, 64, 74, 76, 65, 30, true, true, false, true, false, false, false)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(16, 36, 76, 12, 71, 71, true, true, false, true, true, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "DACH Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(33, 39, 63, 27, 13, 20, true, false, false, true, true, false, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "AMER Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Stage": "Validation",
			"Percentage": new PercentageMetrics(49, 61, 48, 67, 14, 86, true, true, false, false, false, true, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "EMEA Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Stage": "Validation",
			"Percentage": new PercentageMetrics(37, 70, 77, 36, 85, 17, true, false, true, true, false, false, true)
		},
		{
			"ApplicationGroup": "Salesforce",
			"Team": "APAC Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Stage": "Validation",
			"Percentage": new PercentageMetrics(62, 56, 23, 30, 63, 72, true, true, false, false, true, true, true)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH Account Executives",
			"Capability": "Contract & SLA Management",
			"Stage": "Negotiation",
			"Percentage": new PercentageMetrics(92, 50, 35, 47, 30, 46, true, true, true, false, true, false, false)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Stage": "Negotiation",
			"Percentage": new PercentageMetrics(15, 13, 93, 57, 70, 41, true, true, false, true, true, true, true)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Stage": "PO Received",
			"Percentage": new PercentageMetrics(59, 71, 90, 73, 13, 10, true, false, false, true, true, false, false)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Stage": "Technology",
			"Percentage": new PercentageMetrics(55, 44, 45, 62, 64, 68, true, true, false, false, false, true, false)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Stage": "Technology",
			"Percentage": new PercentageMetrics(67, 76, 14, 76, 30, 64, true, true, false, true, true, false, false)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH Legal",
			"Capability": "Compliance & Risk Assessment",
			"Stage": "Procurement",
			"Percentage": new PercentageMetrics(52, 50, 12, 65, 59, 87, true, false, true, true, false, false, true)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH Legal",
			"Capability": "Procurement Process Navigation",
			"Stage": "Procurement",
			"Percentage": new PercentageMetrics(20, 12, 13, 83, 72, 35, true, true, false, false, false, true, false)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Stage": "Discovery",
			"Percentage": new PercentageMetrics(85, 28, 75, 66, 71, 82, true, false, false, true, true, false, true)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(28, 34, 26, 19, 86, 85, true, false, true, true, true, false, true)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "APAC Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(42, 39, 16, 55, 74, 21, true, true, true, true, true, true, false)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "AMER Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(94, 82, 28, 51, 93, 35, true, true, true, false, true, false, false)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "EMEA Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(53, 11, 49, 94, 10, 72, true, true, true, false, true, true, false)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Stage": "Pricing",
			"Percentage": new PercentageMetrics(25, 16, 60, 16, 25, 88, true, false, false, false, false, true, true)
		},
		{
			"ApplicationGroup": "Dynamics365",
			"Team": "DACH Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Stage": "Validation",
			"Percentage": new PercentageMetrics(25, 86, 79, 10, 62, 76, true, true, true, true, true, true, false)
		},
		{
			"ApplicationGroup": "Docusign",
			"Team": "AMER Legal",
			"Capability": "Compliance & Risk Assessment",
			"Stage": "Procurement",
			"Percentage": new PercentageMetrics(89, 26, 29, 35, 87, 38, true, false, false, false, false, false, false)
		},
		{
			"ApplicationGroup": "Docusign",
			"Team": "EMEA Legal",
			"Capability": "Compliance & Risk Assessment",
			"Stage": "Procurement",
			"Percentage": new PercentageMetrics(94, 26, 94, 37, 92, 74, true, true, false, false, true, true, false)
		},
		{
			"ApplicationGroup": "Docusign",
			"Team": "APAC Legal",
			"Capability": "Compliance & Risk Assessment",
			"Stage": "Procurement",
			"Percentage": new PercentageMetrics(61, 31, 81, 71, 15, 50, true, true, false, true, false, true, false)
		},
		{
			"ApplicationGroup": "Gainsight",
			"Team": "AMER CSMs",
			"Capability": "Customer Success Handover",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(85, 29, 48, 17, 54, 34, true, false, false, true, true, true, false)
		},
		{
			"ApplicationGroup": "Gainsight",
			"Team": "APAC CSMs",
			"Capability": "Customer Success Handover",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(27, 13, 68, 70, 12, 55, true, false, false, false, false, false, true)
		},
		{
			"ApplicationGroup": "Gainsight",
			"Team": "EMEA CSMs",
			"Capability": "Customer Success Handover",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(65, 11, 72, 69, 72, 67, true, false, false, true, true, true, true)
		},
		{
			"ApplicationGroup": "Gainsight",
			"Team": "APAC CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(55, 39, 26, 23, 66, 57, true, false, true, false, true, false, true)
		},
		{
			"ApplicationGroup": "Gainsight",
			"Team": "AMER CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(51, 29, 10, 32, 44, 87, true, false, true, false, true, true, false)
		},
		{
			"ApplicationGroup": "Gainsight",
			"Team": "EMEA CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(18, 30, 31, 45, 32, 41, true, false, true, true, true, true, true)
		},
		{
			"ApplicationGroup": "ChurnZero",
			"Team": "DACH CSMs",
			"Capability": "Customer Success Handover",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(67, 26, 29, 11, 89, 29, true, false, false, false, false, true, false)
		},
		{
			"ApplicationGroup": "ChurnZero",
			"Team": "DACH CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Stage": "Closed Won",
			"Percentage": new PercentageMetrics(30, 84, 19, 53, 95, 16, true, true, false, true, true, false, true)
		}
	],
	"teams": [
		{
			"team": "APAC Account Executives",
			"capability": "Contract & SLA Management",
			"stage": "Negotiation",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(16, 43, 64, 62, 76, 49, true, true, false, false, false, false, false)
		},
		{
			"team": "EMEA Account Executives",
			"capability": "Contract & SLA Management",
			"stage": "Negotiation",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(16, 45, 57, 50, 86, 90, true, true, false, false, false, false, false)
		},
		{
			"team": "AMER Account Executives",
			"capability": "Contract & SLA Management",
			"stage": "Negotiation",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(72, 72, 24, 45, 21, 22, true, false, true, true, true, false, true)
		},
		{
			"team": "DACH Account Executives",
			"capability": "Contract & SLA Management",
			"stage": "Negotiation",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(20, 86, 88, 24, 59, 64, true, true, false, true, true, false, true)
		},
		{
			"team": "AMER Account Executives",
			"capability": "Objection Handling & Competitive Analysis",
			"stage": "Negotiation",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(50, 91, 94, 62, 59, 67, true, false, false, false, true, false, true)
		},
		{
			"team": "APAC Account Executives",
			"capability": "Objection Handling & Competitive Analysis",
			"stage": "Negotiation",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(76, 67, 56, 43, 23, 73, true, false, true, false, false, false, true)
		},
		{
			"team": "EMEA Account Executives",
			"capability": "Objection Handling & Competitive Analysis",
			"stage": "Negotiation",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(82, 93, 70, 75, 21, 63, true, true, true, false, false, true, false)
		},
		{
			"team": "DACH Account Executives",
			"capability": "Objection Handling & Competitive Analysis",
			"stage": "Negotiation",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(67, 38, 75, 16, 10, 34, true, false, true, false, false, true, false)
		},
		{
			"team": "AMER Account Executives",
			"capability": "Order Processing & Billing Setup",
			"stage": "PO Received",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(76, 66, 49, 40, 18, 64, true, true, false, false, false, true, false)
		},
		{
			"team": "EMEA Account Executives",
			"capability": "Order Processing & Billing Setup",
			"stage": "PO Received",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(48, 52, 43, 27, 13, 53, true, false, true, true, true, false, true)
		},
		{
			"team": "APAC Account Executives",
			"capability": "Order Processing & Billing Setup",
			"stage": "PO Received",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(27, 58, 46, 78, 26, 51, true, false, false, false, false, false, true)
		},
		{
			"team": "DACH Account Executives",
			"capability": "Order Processing & Billing Setup",
			"stage": "PO Received",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(50, 62, 89, 14, 59, 53, true, false, true, false, false, true, false)
		},
		{
			"team": "APAC Solution Consultants",
			"capability": "Product Demonstration & Proof of Concept (PoC)",
			"stage": "Technology",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(43, 15, 70, 54, 56, 31, true, false, true, false, true, true, false)
		},
		{
			"team": "AMER Account Executives",
			"capability": "Product Demonstration & Proof of Concept (PoC)",
			"stage": "Technology",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(90, 92, 59, 65, 47, 71, true, true, false, false, false, false, true)
		},
		{
			"team": "EMEA Account Executives",
			"capability": "Product Demonstration & Proof of Concept (PoC)",
			"stage": "Technology",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(64, 45, 32, 66, 75, 51, true, false, false, false, false, false, true)
		},
		{
			"team": "AMER Solution Consultants",
			"capability": "Product Demonstration & Proof of Concept (PoC)",
			"stage": "Technology",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(68, 68, 26, 49, 16, 48, true, false, false, false, true, false, true)
		},
		{
			"team": "APAC Account Executives",
			"capability": "Product Demonstration & Proof of Concept (PoC)",
			"stage": "Technology",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(71, 21, 12, 35, 95, 61, true, false, false, false, true, true, true)
		},
		{
			"team": "EMEA Solution Consultants",
			"capability": "Product Demonstration & Proof of Concept (PoC)",
			"stage": "Technology",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(94, 14, 29, 80, 86, 57, true, true, false, true, true, true, false)
		},
		{
			"team": "DACH Account Executives",
			"capability": "Product Demonstration & Proof of Concept (PoC)",
			"stage": "Technology",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(22, 55, 66, 31, 34, 49, true, true, false, false, true, true, false)
		},
		{
			"team": "DACH Solution Consultants",
			"capability": "Product Demonstration & Proof of Concept (PoC)",
			"stage": "Technology",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(37, 90, 31, 25, 73, 85, true, false, false, true, true, false, false)
		},
		{
			"team": "AMER Legal",
			"capability": "Compliance & Risk Assessment",
			"stage": "Procurement",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(73, 48, 23, 88, 11, 73, true, true, false, false, false, false, true)
		},
		{
			"team": "EMEA Legal",
			"capability": "Compliance & Risk Assessment",
			"stage": "Procurement",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(33, 88, 38, 24, 10, 17, true, true, false, false, true, false, true)
		},
		{
			"team": "APAC Legal",
			"capability": "Compliance & Risk Assessment",
			"stage": "Procurement",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(66, 48, 31, 15, 25, 89, true, false, true, true, true, true, true)
		},
		{
			"team": "DACH Legal",
			"capability": "Compliance & Risk Assessment",
			"stage": "Procurement",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(24, 32, 21, 28, 83, 42, true, true, false, false, false, false, false)
		},
		{
			"team": "APAC Legal",
			"capability": "Procurement Process Navigation",
			"stage": "Procurement",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(39, 93, 41, 23, 39, 66, true, true, true, false, true, false, true)
		},
		{
			"team": "EMEA Legal",
			"capability": "Procurement Process Navigation",
			"stage": "Procurement",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(72, 22, 14, 43, 22, 45, true, true, false, true, false, false, false)
		},
		{
			"team": "AMER Legal",
			"capability": "Procurement Process Navigation",
			"stage": "Procurement",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(28, 37, 18, 28, 43, 44, true, true, true, false, false, false, true)
		},
		{
			"team": "DACH Legal",
			"capability": "Procurement Process Navigation",
			"stage": "Procurement",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(74, 28, 77, 94, 51, 53, true, false, false, false, true, false, false)
		},
		{
			"team": "AMER CSMs",
			"capability": "Customer Success Handover",
			"stage": "Closed Won",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(65, 28, 85, 33, 72, 54, true, false, true, true, true, false, false)
		},
		{
			"team": "APAC CSMs",
			"capability": "Customer Success Handover",
			"stage": "Closed Won",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(91, 55, 21, 24, 77, 11, true, false, false, true, true, true, true)
		},
		{
			"team": "EMEA CSMs",
			"capability": "Customer Success Handover",
			"stage": "Closed Won",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(69, 72, 83, 59, 54, 22, true, false, true, true, true, false, false)
		},
		{
			"team": "DACH CSMs",
			"capability": "Customer Success Handover",
			"stage": "Closed Won",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(35, 20, 14, 45, 57, 52, true, false, true, true, true, true, true)
		},
		{
			"team": "APAC CSMs",
			"capability": "Upsell & Expansion Strategy",
			"stage": "Closed Won",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(70, 80, 60, 59, 13, 61, true, false, true, false, true, false, true)
		},
		{
			"team": "AMER CSMs",
			"capability": "Upsell & Expansion Strategy",
			"stage": "Closed Won",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(10, 55, 28, 95, 33, 38, true, true, true, false, false, false, true)
		},
		{
			"team": "EMEA CSMs",
			"capability": "Upsell & Expansion Strategy",
			"stage": "Closed Won",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(35, 21, 78, 41, 45, 76, true, false, true, true, true, true, true)
		},
		{
			"team": "DACH CSMs",
			"capability": "Upsell & Expansion Strategy",
			"stage": "Closed Won",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(80, 76, 11, 46, 65, 68, true, false, false, true, false, true, true)
		},
		{
			"team": "EMEA BDRs",
			"capability": "Market Intelligence & Lead Generation",
			"stage": "Discovery",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(60, 76, 81, 31, 62, 15, true, true, true, true, true, false, true)
		},
		{
			"team": "APAC BDRs",
			"capability": "Market Intelligence & Lead Generation",
			"stage": "Discovery",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(83, 64, 69, 36, 81, 18, true, true, true, false, true, true, true)
		},
		{
			"team": "AMER BDRs",
			"capability": "Market Intelligence & Lead Generation",
			"stage": "Discovery",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(74, 17, 15, 58, 71, 48, true, true, false, false, false, false, false)
		},
		{
			"team": "DACH BDRs",
			"capability": "Market Intelligence & Lead Generation",
			"stage": "Discovery",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(27, 16, 73, 49, 84, 61, true, false, false, false, false, false, false)
		},
		{
			"team": "AMER Account Executives",
			"capability": "Deal Structuring & Pricing Optimisation",
			"stage": "Pricing",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(39, 90, 64, 82, 18, 53, true, true, false, true, false, false, true)
		},
		{
			"team": "EMEA Account Executives",
			"capability": "Deal Structuring & Pricing Optimisation",
			"stage": "Pricing",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(58, 74, 48, 87, 92, 57, true, true, true, false, false, false, true)
		},
		{
			"team": "APAC Account Executives",
			"capability": "Deal Structuring & Pricing Optimisation",
			"stage": "Pricing",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(92, 78, 95, 49, 37, 42, true, false, true, false, false, false, false)
		},
		{
			"team": "DACH Account Executives",
			"capability": "Deal Structuring & Pricing Optimisation",
			"stage": "Pricing",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(66, 43, 65, 78, 89, 40, true, true, true, false, true, true, false)
		},
		{
			"team": "APAC Account Executives",
			"capability": "ROI & Business Case Modelling",
			"stage": "Pricing",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(59, 74, 19, 72, 84, 52, true, false, true, false, false, true, false)
		},
		{
			"team": "AMER Account Executives",
			"capability": "ROI & Business Case Modelling",
			"stage": "Pricing",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(30, 94, 73, 65, 68, 68, true, false, false, true, false, true, true)
		},
		{
			"team": "EMEA Account Executives",
			"capability": "ROI & Business Case Modelling",
			"stage": "Pricing",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(30, 37, 65, 18, 94, 55, true, false, true, true, false, false, false)
		},
		{
			"team": "DACH Account Executives",
			"capability": "ROI & Business Case Modelling",
			"stage": "Pricing",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(48, 15, 83, 53, 71, 91, true, true, true, false, true, false, true)
		},
		{
			"team": "AMER Account Executives",
			"capability": "Lead Qualification & Scoring",
			"stage": "Validation",
			"Territory": "AMER",
			"Percentage": new PercentageMetrics(51, 81, 79, 52, 72, 31, true, true, false, true, false, false, false)
		},
		{
			"team": "EMEA Account Executives",
			"capability": "Lead Qualification & Scoring",
			"stage": "Validation",
			"Territory": "EMEA",
			"Percentage": new PercentageMetrics(66, 54, 56, 56, 82, 51, true, false, true, false, true, true, false)
		},
		{
			"team": "APAC Account Executives",
			"capability": "Lead Qualification & Scoring",
			"stage": "Validation",
			"Territory": "APAC",
			"Percentage": new PercentageMetrics(19, 95, 47, 81, 29, 81, true, true, true, true, false, true, false)
		},
		{
			"team": "DACH Account Executives",
			"capability": "Lead Qualification & Scoring",
			"stage": "Validation",
			"Territory": "DACH",
			"Percentage": new PercentageMetrics(63, 85, 24, 51, 69, 62, true, false, false, true, false, true, true)
		}
	],
	"flows": [
		{
			"SourceLeaf": "Complete Customer Handover",
			"TargetLeaf": "Customer Handover Completed",
			"SourceTeam": "AMER CSMs",
			"TargetTeam": "AMER CSMs"
		},
		{
			"SourceLeaf": "Complete Customer Handover",
			"TargetLeaf": "Customer Handover Completed",
			"SourceTeam": "APAC CSMs",
			"TargetTeam": "APAC CSMs"
		},
		{
			"SourceLeaf": "Complete Customer Handover",
			"TargetLeaf": "Customer Handover Completed",
			"SourceTeam": "EMEA CSMs",
			"TargetTeam": "EMEA CSMs"
		},
		{
			"SourceLeaf": "Complete Customer Handover",
			"TargetLeaf": "Customer Handover Completed",
			"SourceTeam": "DACH CSMs",
			"TargetTeam": "DACH CSMs"
		},
		{
			"SourceLeaf": "Expand Opportunity",
			"TargetLeaf": "Expanded Opportunity",
			"SourceTeam": "AMER CSMs",
			"TargetTeam": "AMER CSMs"
		},
		{
			"SourceLeaf": "Expand Opportunity",
			"TargetLeaf": "Expanded Opportunity",
			"SourceTeam": "APAC CSMs",
			"TargetTeam": "APAC CSMs"
		},
		{
			"SourceLeaf": "Expand Opportunity",
			"TargetLeaf": "Expanded Opportunity",
			"SourceTeam": "EMEA CSMs",
			"TargetTeam": "EMEA CSMs"
		},
		{
			"SourceLeaf": "Expand Opportunity",
			"TargetLeaf": "Expanded Opportunity",
			"SourceTeam": "DACH CSMs",
			"TargetTeam": "DACH CSMs"
		},
		{
			"SourceLeaf": "Capture Lead",
			"TargetLeaf": "Captured Lead",
			"SourceTeam": "AMER BDRs",
			"TargetTeam": "AMER BDRs"
		},
		{
			"SourceLeaf": "Captured Lead",
			"TargetLeaf": "Qualify Lead",
			"SourceTeam": "AMER BDRs",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Capture Lead",
			"TargetLeaf": "Captured Lead",
			"SourceTeam": "APAC BDRs",
			"TargetTeam": "APAC BDRs"
		},
		{
			"SourceLeaf": "Captured Lead",
			"TargetLeaf": "Qualify Lead",
			"SourceTeam": "APAC BDRs",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Capture Lead",
			"TargetLeaf": "Captured Lead",
			"SourceTeam": "EMEA BDRs",
			"TargetTeam": "EMEA BDRs"
		},
		{
			"SourceLeaf": "Captured Lead",
			"TargetLeaf": "Qualify Lead",
			"SourceTeam": "EMEA BDRs",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Capture Lead",
			"TargetLeaf": "Captured Lead",
			"SourceTeam": "DACH BDRs",
			"TargetTeam": "DACH BDRs"
		},
		{
			"SourceLeaf": "Captured Lead",
			"TargetLeaf": "Qualify Lead",
			"SourceTeam": "DACH BDRs",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Create Opportunity Contract",
			"TargetLeaf": "Opportunity Contract Created",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "AMER Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Contract Created",
			"TargetLeaf": "Approve Opportunity Purchase",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "DACH Legal"
		},
		{
			"SourceLeaf": "Create Opportunity Contract",
			"TargetLeaf": "Opportunity Contract Created",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "APAC Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Contract Created",
			"TargetLeaf": "Approve Opportunity Purchase",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "DACH Legal"
		},
		{
			"SourceLeaf": "Create Opportunity Contract",
			"TargetLeaf": "Opportunity Contract Created",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "EMEA Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Contract Created",
			"TargetLeaf": "Approve Opportunity Purchase",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "DACH Legal"
		},
		{
			"SourceLeaf": "Create Opportunity Contract",
			"TargetLeaf": "Opportunity Contract Created",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Contract Created",
			"TargetLeaf": "Approve Opportunity Purchase",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Legal"
		},
		{
			"SourceLeaf": "Clear Opportunity Objections",
			"TargetLeaf": "Opportunity Objections Cleared",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "AMER Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Objections Cleared",
			"TargetLeaf": "Assess Opportunity Risk",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "DACH Legal"
		},
		{
			"SourceLeaf": "Clear Opportunity Objections",
			"TargetLeaf": "Opportunity Objections Cleared",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "APAC Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Objections Cleared",
			"TargetLeaf": "Assess Opportunity Risk",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "DACH Legal"
		},
		{
			"SourceLeaf": "Clear Opportunity Objections",
			"TargetLeaf": "Opportunity Objections Cleared",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "EMEA Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Objections Cleared",
			"TargetLeaf": "Assess Opportunity Risk",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "DACH Legal"
		},
		{
			"SourceLeaf": "Clear Opportunity Objections",
			"TargetLeaf": "Opportunity Objections Cleared",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Objections Cleared",
			"TargetLeaf": "Assess Opportunity Risk",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Legal"
		},
		{
			"SourceLeaf": "Create Order",
			"TargetLeaf": "Created Order",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "AMER Account Executives"
		},
		{
			"SourceLeaf": "Created Order",
			"TargetLeaf": "Complete Customer Handover",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "DACH CSMs"
		},
		{
			"SourceLeaf": "Created Order",
			"TargetLeaf": "Expand Opportunity",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "DACH CSMs"
		},
		{
			"SourceLeaf": "Create Order",
			"TargetLeaf": "Created Order",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "APAC Account Executives"
		},
		{
			"SourceLeaf": "Created Order",
			"TargetLeaf": "Expand Opportunity",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "DACH CSMs"
		},
		{
			"SourceLeaf": "Created Order",
			"TargetLeaf": "Complete Customer Handover",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "DACH CSMs"
		},
		{
			"SourceLeaf": "Create Order",
			"TargetLeaf": "Created Order",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "EMEA Account Executives"
		},
		{
			"SourceLeaf": "Created Order",
			"TargetLeaf": "Complete Customer Handover",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "DACH CSMs"
		},
		{
			"SourceLeaf": "Created Order",
			"TargetLeaf": "Expand Opportunity",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "DACH CSMs"
		},
		{
			"SourceLeaf": "Create Order",
			"TargetLeaf": "Created Order",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Created Order",
			"TargetLeaf": "Expand Opportunity",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH CSMs"
		},
		{
			"SourceLeaf": "Created Order",
			"TargetLeaf": "Complete Customer Handover",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH CSMs"
		},
		{
			"SourceLeaf": "Validate Opportunity Solution",
			"TargetLeaf": "Opportunity Solution Validated",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "AMER Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Solution Validated",
			"TargetLeaf": "Clear Opportunity Objections",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Solution Validated",
			"TargetLeaf": "Create Opportunity Contract",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Validate Opportunity Solution",
			"TargetLeaf": "Opportunity Solution Validated",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "APAC Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Solution Validated",
			"TargetLeaf": "Create Opportunity Contract",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Solution Validated",
			"TargetLeaf": "Clear Opportunity Objections",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Validate Opportunity Solution",
			"TargetLeaf": "Opportunity Solution Validated",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "EMEA Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Solution Validated",
			"TargetLeaf": "Create Opportunity Contract",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Solution Validated",
			"TargetLeaf": "Clear Opportunity Objections",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Validate Opportunity Solution",
			"TargetLeaf": "Opportunity Solution Validated",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Solution Validated",
			"TargetLeaf": "Create Opportunity Contract",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Solution Validated",
			"TargetLeaf": "Clear Opportunity Objections",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Assess Opportunity Risk",
			"TargetLeaf": "Opportunity Risk Assessed",
			"SourceTeam": "AMER Legal",
			"TargetTeam": "AMER Legal"
		},
		{
			"SourceLeaf": "Opportunity Risk Assessed",
			"TargetLeaf": "Create Order",
			"SourceTeam": "AMER Legal",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Assess Opportunity Risk",
			"TargetLeaf": "Opportunity Risk Assessed",
			"SourceTeam": "APAC Legal",
			"TargetTeam": "APAC Legal"
		},
		{
			"SourceLeaf": "Opportunity Risk Assessed",
			"TargetLeaf": "Create Order",
			"SourceTeam": "APAC Legal",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Assess Opportunity Risk",
			"TargetLeaf": "Opportunity Risk Assessed",
			"SourceTeam": "EMEA Legal",
			"TargetTeam": "EMEA Legal"
		},
		{
			"SourceLeaf": "Opportunity Risk Assessed",
			"TargetLeaf": "Create Order",
			"SourceTeam": "EMEA Legal",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Assess Opportunity Risk",
			"TargetLeaf": "Opportunity Risk Assessed",
			"SourceTeam": "DACH Legal",
			"TargetTeam": "DACH Legal"
		},
		{
			"SourceLeaf": "Opportunity Risk Assessed",
			"TargetLeaf": "Create Order",
			"SourceTeam": "DACH Legal",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Approve Opportunity Purchase",
			"TargetLeaf": "Opportunity Purchase Approved",
			"SourceTeam": "AMER Legal",
			"TargetTeam": "AMER Legal"
		},
		{
			"SourceLeaf": "Opportunity Purchase Approved",
			"TargetLeaf": "Create Order",
			"SourceTeam": "AMER Legal",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Approve Opportunity Purchase",
			"TargetLeaf": "Opportunity Purchase Approved",
			"SourceTeam": "APAC Legal",
			"TargetTeam": "APAC Legal"
		},
		{
			"SourceLeaf": "Opportunity Purchase Approved",
			"TargetLeaf": "Create Order",
			"SourceTeam": "APAC Legal",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Approve Opportunity Purchase",
			"TargetLeaf": "Opportunity Purchase Approved",
			"SourceTeam": "EMEA Legal",
			"TargetTeam": "EMEA Legal"
		},
		{
			"SourceLeaf": "Opportunity Purchase Approved",
			"TargetLeaf": "Create Order",
			"SourceTeam": "EMEA Legal",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Approve Opportunity Purchase",
			"TargetLeaf": "Opportunity Purchase Approved",
			"SourceTeam": "DACH Legal",
			"TargetTeam": "DACH Legal"
		},
		{
			"SourceLeaf": "Opportunity Purchase Approved",
			"TargetLeaf": "Create Order",
			"SourceTeam": "DACH Legal",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Complete Opportunity Demo",
			"TargetLeaf": "Opportunity Demo Completed",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "AMER Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Demo Completed",
			"TargetLeaf": "Validate Opportunity Solution",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Complete Opportunity Demo",
			"TargetLeaf": "Opportunity Demo Completed",
			"SourceTeam": "AMER Solution Consultants",
			"TargetTeam": "AMER Solution Consultants"
		},
		{
			"SourceLeaf": "Opportunity Demo Completed",
			"TargetLeaf": "Validate Opportunity Solution",
			"SourceTeam": "AMER Solution Consultants",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Complete Opportunity Demo",
			"TargetLeaf": "Opportunity Demo Completed",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "APAC Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Demo Completed",
			"TargetLeaf": "Validate Opportunity Solution",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Complete Opportunity Demo",
			"TargetLeaf": "Opportunity Demo Completed",
			"SourceTeam": "APAC Solution Consultants",
			"TargetTeam": "APAC Solution Consultants"
		},
		{
			"SourceLeaf": "Opportunity Demo Completed",
			"TargetLeaf": "Validate Opportunity Solution",
			"SourceTeam": "APAC Solution Consultants",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Complete Opportunity Demo",
			"TargetLeaf": "Opportunity Demo Completed",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "EMEA Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Demo Completed",
			"TargetLeaf": "Validate Opportunity Solution",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Complete Opportunity Demo",
			"TargetLeaf": "Opportunity Demo Completed",
			"SourceTeam": "EMEA Solution Consultants",
			"TargetTeam": "EMEA Solution Consultants"
		},
		{
			"SourceLeaf": "Opportunity Demo Completed",
			"TargetLeaf": "Validate Opportunity Solution",
			"SourceTeam": "EMEA Solution Consultants",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Complete Opportunity Demo",
			"TargetLeaf": "Opportunity Demo Completed",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Opportunity Demo Completed",
			"TargetLeaf": "Validate Opportunity Solution",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Complete Opportunity Demo",
			"TargetLeaf": "Opportunity Demo Completed",
			"SourceTeam": "DACH Solution Consultants",
			"TargetTeam": "DACH Solution Consultants"
		},
		{
			"SourceLeaf": "Opportunity Demo Completed",
			"TargetLeaf": "Validate Opportunity Solution",
			"SourceTeam": "DACH Solution Consultants",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Qualify Lead",
			"TargetLeaf": "Qualified Lead",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "AMER Account Executives"
		},
		{
			"SourceLeaf": "Qualified Lead",
			"TargetLeaf": "Complete Opportunity Demo",
			"SourceTeam": "AMER Account Executives",
			"TargetTeam": "DACH Solution Consultants"
		},
		{
			"SourceLeaf": "Qualify Lead",
			"TargetLeaf": "Qualified Lead",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "APAC Account Executives"
		},
		{
			"SourceLeaf": "Qualified Lead",
			"TargetLeaf": "Complete Opportunity Demo",
			"SourceTeam": "APAC Account Executives",
			"TargetTeam": "DACH Solution Consultants"
		},
		{
			"SourceLeaf": "Qualify Lead",
			"TargetLeaf": "Qualified Lead",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "EMEA Account Executives"
		},
		{
			"SourceLeaf": "Qualified Lead",
			"TargetLeaf": "Complete Opportunity Demo",
			"SourceTeam": "EMEA Account Executives",
			"TargetTeam": "DACH Solution Consultants"
		},
		{
			"SourceLeaf": "Qualify Lead",
			"TargetLeaf": "Qualified Lead",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Account Executives"
		},
		{
			"SourceLeaf": "Qualified Lead",
			"TargetLeaf": "Complete Opportunity Demo",
			"SourceTeam": "DACH Account Executives",
			"TargetTeam": "DACH Solution Consultants"
		}
	],
	"leafs": [
		{
			"Leaf": "Create Opportunity Contract",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "APAC Account Executives",
			"Capability": "Contract & SLA Management",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(81, 36, 94, 37, 59, 83, true, true, true, true, true, false, false)
		},
		{
			"Leaf": "Create Opportunity Contract",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "EMEA Account Executives",
			"Capability": "Contract & SLA Management",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(62, 35, 87, 72, 79, 63, true, true, false, true, false, false, false)
		},
		{
			"Leaf": "Create Opportunity Contract",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "AMER Account Executives",
			"Capability": "Contract & SLA Management",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(33, 37, 61, 86, 12, 73, true, false, true, true, false, false, false)
		},
		{
			"Leaf": "Opportunity Contract Created",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "APAC Account Executives",
			"Capability": "Contract & SLA Management",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(12, 60, 47, 68, 91, 81, true, false, false, true, false, true, true)
		},
		{
			"Leaf": "Opportunity Contract Created",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "EMEA Account Executives",
			"Capability": "Contract & SLA Management",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(59, 17, 39, 33, 28, 29, true, true, false, true, false, false, true)
		},
		{
			"Leaf": "Opportunity Contract Created",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "AMER Account Executives",
			"Capability": "Contract & SLA Management",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(84, 37, 35, 82, 59, 68, true, true, false, false, true, true, true)
		},
		{
			"Leaf": "Create Opportunity Contract",
			"Application": "Dynamics365",
			"Stage": "Negotiation",
			"Team": "DACH Account Executives",
			"Capability": "Contract & SLA Management",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(73, 75, 11, 18, 21, 18, true, true, false, true, false, false, false)
		},
		{
			"Leaf": "Opportunity Contract Created",
			"Application": "Dynamics365",
			"Stage": "Negotiation",
			"Team": "DACH Account Executives",
			"Capability": "Contract & SLA Management",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(18, 34, 26, 46, 44, 13, true, false, false, false, true, true, false)
		},
		{
			"Leaf": "Clear Opportunity Objections",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "AMER Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(28, 62, 69, 42, 12, 77, true, false, false, true, false, true, false)
		},
		{
			"Leaf": "Clear Opportunity Objections",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "APAC Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(10, 19, 75, 70, 38, 65, true, false, false, true, true, true, true)
		},
		{
			"Leaf": "Clear Opportunity Objections",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "EMEA Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(25, 36, 58, 17, 61, 79, true, true, true, true, true, false, false)
		},
		{
			"Leaf": "Opportunity Objections Cleared",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "AMER Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(86, 80, 35, 81, 91, 24, true, true, true, false, true, false, false)
		},
		{
			"Leaf": "Opportunity Objections Cleared",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "APAC Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(95, 93, 22, 38, 70, 56, true, true, false, true, false, false, false)
		},
		{
			"Leaf": "Opportunity Objections Cleared",
			"Application": "Salesforce",
			"Stage": "Negotiation",
			"Team": "EMEA Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(71, 33, 19, 89, 91, 38, true, false, false, true, false, false, false)
		},
		{
			"Leaf": "Clear Opportunity Objections",
			"Application": "Dynamics365",
			"Stage": "Negotiation",
			"Team": "DACH Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(39, 28, 51, 83, 74, 56, true, false, false, true, true, false, true)
		},
		{
			"Leaf": "Opportunity Objections Cleared",
			"Application": "Dynamics365",
			"Stage": "Negotiation",
			"Team": "DACH Account Executives",
			"Capability": "Objection Handling & Competitive Analysis",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(59, 92, 25, 19, 29, 93, true, true, false, true, true, false, true)
		},
		{
			"Leaf": "Create Order",
			"Application": "Salesforce",
			"Stage": "PO Received",
			"Team": "AMER Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(76, 33, 81, 66, 47, 21, true, true, false, false, true, true, true)
		},
		{
			"Leaf": "Create Order",
			"Application": "Salesforce",
			"Stage": "PO Received",
			"Team": "EMEA Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(29, 23, 38, 78, 71, 31, true, false, false, true, false, false, false)
		},
		{
			"Leaf": "Create Order",
			"Application": "Salesforce",
			"Stage": "PO Received",
			"Team": "APAC Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(92, 40, 92, 30, 63, 56, true, true, false, true, true, false, false)
		},
		{
			"Leaf": "Created Order",
			"Application": "Salesforce",
			"Stage": "PO Received",
			"Team": "AMER Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(50, 53, 63, 94, 45, 18, true, true, false, true, true, false, true)
		},
		{
			"Leaf": "Created Order",
			"Application": "Salesforce",
			"Stage": "PO Received",
			"Team": "EMEA Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(37, 95, 47, 61, 73, 66, true, true, false, false, true, false, false)
		},
		{
			"Leaf": "Created Order",
			"Application": "Salesforce",
			"Stage": "PO Received",
			"Team": "APAC Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(89, 34, 95, 91, 80, 35, true, true, false, false, true, true, true)
		},
		{
			"Leaf": "Create Order",
			"Application": "Dynamics365",
			"Stage": "PO Received",
			"Team": "DACH Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(76, 75, 26, 60, 31, 11, true, true, false, false, false, true, true)
		},
		{
			"Leaf": "Created Order",
			"Application": "Dynamics365",
			"Stage": "PO Received",
			"Team": "DACH Account Executives",
			"Capability": "Order Processing & Billing Setup",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(81, 45, 41, 34, 23, 79, true, false, false, true, true, true, true)
		},
		{
			"Leaf": "Complete Opportunity Demo",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "APAC Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(15, 68, 38, 73, 84, 22, true, true, true, true, true, false, false)
		},
		{
			"Leaf": "Complete Opportunity Demo",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "AMER Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(79, 47, 95, 82, 72, 49, true, false, true, false, true, true, true)
		},
		{
			"Leaf": "Complete Opportunity Demo",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "EMEA Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(40, 57, 62, 29, 84, 72, true, true, false, true, false, false, false)
		},
		{
			"Leaf": "Complete Opportunity Demo",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "AMER Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(27, 78, 56, 69, 41, 37, true, false, true, true, false, true, true)
		},
		{
			"Leaf": "Complete Opportunity Demo",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "APAC Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(27, 25, 16, 74, 74, 63, true, false, false, false, false, true, false)
		},
		{
			"Leaf": "Complete Opportunity Demo",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "EMEA Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(44, 14, 86, 58, 43, 17, true, true, true, true, false, true, false)
		},
		{
			"Leaf": "Opportunity Demo Completed",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "APAC Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(13, 64, 57, 62, 33, 93, true, true, true, false, false, false, false)
		},
		{
			"Leaf": "Opportunity Demo Completed",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "AMER Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(29, 31, 72, 91, 71, 62, true, true, false, true, false, false, false)
		},
		{
			"Leaf": "Opportunity Demo Completed",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "EMEA Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(58, 58, 18, 81, 59, 73, true, true, true, false, true, false, false)
		},
		{
			"Leaf": "Opportunity Demo Completed",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "AMER Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(14, 21, 67, 22, 55, 37, true, true, false, true, false, true, false)
		},
		{
			"Leaf": "Opportunity Demo Completed",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "APAC Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(70, 43, 93, 72, 51, 35, true, true, false, false, true, false, true)
		},
		{
			"Leaf": "Opportunity Demo Completed",
			"Application": "Salesforce",
			"Stage": "Technology",
			"Team": "EMEA Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(91, 41, 74, 58, 50, 23, true, false, false, true, true, false, false)
		},
		{
			"Leaf": "Complete Opportunity Demo",
			"Application": "Dynamics365",
			"Stage": "Technology",
			"Team": "DACH Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(86, 49, 12, 33, 10, 47, true, true, true, true, true, false, true)
		},
		{
			"Leaf": "Complete Opportunity Demo",
			"Application": "Dynamics365",
			"Stage": "Technology",
			"Team": "DACH Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(16, 42, 75, 67, 84, 90, true, true, false, true, false, true, false)
		},
		{
			"Leaf": "Opportunity Demo Completed",
			"Application": "Dynamics365",
			"Stage": "Technology",
			"Team": "DACH Account Executives",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(43, 72, 16, 53, 41, 28, true, true, true, false, true, true, true)
		},
		{
			"Leaf": "Opportunity Demo Completed",
			"Application": "Dynamics365",
			"Stage": "Technology",
			"Team": "DACH Solution Consultants",
			"Capability": "Product Demonstration & Proof of Concept (PoC)",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(56, 76, 31, 11, 59, 60, true, true, true, true, true, true, false)
		},
		{
			"Leaf": "Assess Opportunity Risk",
			"Application": "Docusign",
			"Stage": "Procurement",
			"Team": "AMER Legal",
			"Capability": "Compliance & Risk Assessment",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(18, 72, 30, 14, 76, 62, true, false, true, true, true, true, true)
		},
		{
			"Leaf": "Assess Opportunity Risk",
			"Application": "Docusign",
			"Stage": "Procurement",
			"Team": "EMEA Legal",
			"Capability": "Compliance & Risk Assessment",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(83, 28, 13, 94, 91, 42, true, true, false, true, false, true, true)
		},
		{
			"Leaf": "Assess Opportunity Risk",
			"Application": "Docusign",
			"Stage": "Procurement",
			"Team": "APAC Legal",
			"Capability": "Compliance & Risk Assessment",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(75, 56, 23, 66, 32, 52, true, false, false, true, false, false, true)
		},
		{
			"Leaf": "Opportunity Risk Assessed",
			"Application": "Docusign",
			"Stage": "Procurement",
			"Team": "AMER Legal",
			"Capability": "Compliance & Risk Assessment",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(17, 16, 58, 75, 89, 83, true, true, true, false, false, false, false)
		},
		{
			"Leaf": "Opportunity Risk Assessed",
			"Application": "Docusign",
			"Stage": "Procurement",
			"Team": "EMEA Legal",
			"Capability": "Compliance & Risk Assessment",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(75, 43, 51, 81, 21, 71, true, true, true, true, false, false, false)
		},
		{
			"Leaf": "Opportunity Risk Assessed",
			"Application": "Docusign",
			"Stage": "Procurement",
			"Team": "APAC Legal",
			"Capability": "Compliance & Risk Assessment",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(36, 36, 94, 87, 80, 34, true, true, true, true, false, false, true)
		},
		{
			"Leaf": "Assess Opportunity Risk",
			"Application": "Dynamics365",
			"Stage": "Procurement",
			"Team": "DACH Legal",
			"Capability": "Compliance & Risk Assessment",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(33, 51, 79, 12, 43, 27, true, true, true, false, true, false, true)
		},
		{
			"Leaf": "Opportunity Risk Assessed",
			"Application": "Dynamics365",
			"Stage": "Procurement",
			"Team": "DACH Legal",
			"Capability": "Compliance & Risk Assessment",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(51, 61, 82, 28, 51, 82, true, false, true, false, true, false, false)
		},
		{
			"Leaf": "Approve Opportunity Purchase",
			"Application": "Salesforce",
			"Stage": "Procurement",
			"Team": "APAC Legal",
			"Capability": "Procurement Process Navigation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(51, 15, 15, 34, 67, 51, true, false, true, false, true, true, true)
		},
		{
			"Leaf": "Approve Opportunity Purchase",
			"Application": "Salesforce",
			"Stage": "Procurement",
			"Team": "EMEA Legal",
			"Capability": "Procurement Process Navigation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(13, 47, 48, 40, 20, 63, true, true, true, true, true, false, false)
		},
		{
			"Leaf": "Approve Opportunity Purchase",
			"Application": "Salesforce",
			"Stage": "Procurement",
			"Team": "AMER Legal",
			"Capability": "Procurement Process Navigation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(47, 11, 53, 28, 54, 93, true, false, true, true, false, true, false)
		},
		{
			"Leaf": "Opportunity Purchase Approved",
			"Application": "Salesforce",
			"Stage": "Procurement",
			"Team": "APAC Legal",
			"Capability": "Procurement Process Navigation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(10, 65, 22, 16, 22, 24, true, false, false, false, false, true, true)
		},
		{
			"Leaf": "Opportunity Purchase Approved",
			"Application": "Salesforce",
			"Stage": "Procurement",
			"Team": "EMEA Legal",
			"Capability": "Procurement Process Navigation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(89, 40, 29, 16, 26, 73, true, true, true, false, true, true, true)
		},
		{
			"Leaf": "Opportunity Purchase Approved",
			"Application": "Salesforce",
			"Stage": "Procurement",
			"Team": "AMER Legal",
			"Capability": "Procurement Process Navigation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(36, 95, 62, 33, 12, 92, true, false, true, false, false, false, false)
		},
		{
			"Leaf": "Approve Opportunity Purchase",
			"Application": "Dynamics365",
			"Stage": "Procurement",
			"Team": "DACH Legal",
			"Capability": "Procurement Process Navigation",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(22, 22, 74, 46, 77, 92, true, false, true, true, false, false, false)
		},
		{
			"Leaf": "Opportunity Purchase Approved",
			"Application": "Dynamics365",
			"Stage": "Procurement",
			"Team": "DACH Legal",
			"Capability": "Procurement Process Navigation",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(33, 39, 71, 92, 49, 43, true, false, false, true, false, true, false)
		},
		{
			"Leaf": "Complete Customer Handover",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "AMER CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(54, 11, 39, 57, 17, 68, true, false, true, false, false, true, true)
		},
		{
			"Leaf": "Complete Customer Handover",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "APAC CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(73, 80, 89, 10, 39, 65, true, true, false, false, true, false, true)
		},
		{
			"Leaf": "Complete Customer Handover",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "EMEA CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(74, 29, 93, 14, 71, 92, true, false, false, false, false, false, true)
		},
		{
			"Leaf": "Customer Handover Completed",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "AMER CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(49, 56, 44, 48, 76, 27, true, true, true, true, false, true, false)
		},
		{
			"Leaf": "Customer Handover Completed",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "APAC CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(87, 86, 83, 12, 40, 88, true, true, true, false, false, false, true)
		},
		{
			"Leaf": "Customer Handover Completed",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "EMEA CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(17, 90, 88, 41, 11, 25, true, false, true, false, true, true, false)
		},
		{
			"Leaf": "Complete Customer Handover",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "AMER CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(81, 16, 37, 95, 12, 66, true, true, true, true, false, true, false)
		},
		{
			"Leaf": "Complete Customer Handover",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "APAC CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(27, 18, 45, 82, 46, 84, true, true, true, false, true, false, true)
		},
		{
			"Leaf": "Complete Customer Handover",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "EMEA CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(46, 66, 81, 79, 74, 81, true, true, false, true, true, true, true)
		},
		{
			"Leaf": "Customer Handover Completed",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "AMER CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(47, 51, 33, 76, 93, 80, true, true, true, false, false, false, false)
		},
		{
			"Leaf": "Customer Handover Completed",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "APAC CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(64, 26, 35, 10, 24, 58, true, false, false, false, true, true, true)
		},
		{
			"Leaf": "Customer Handover Completed",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "EMEA CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(39, 81, 65, 87, 58, 77, true, false, false, true, true, true, false)
		},
		{
			"Leaf": "Complete Customer Handover",
			"Application": "ChurnZero",
			"Stage": "Closed Won",
			"Team": "DACH CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(12, 85, 64, 12, 79, 54, true, false, true, false, true, true, false)
		},
		{
			"Leaf": "Customer Handover Completed",
			"Application": "ChurnZero",
			"Stage": "Closed Won",
			"Team": "DACH CSMs",
			"Capability": "Customer Success Handover",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(63, 52, 28, 32, 61, 67, true, true, false, true, false, true, true)
		},
		{
			"Leaf": "Expand Opportunity",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "APAC CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(94, 24, 72, 11, 11, 18, true, true, false, false, false, true, false)
		},
		{
			"Leaf": "Expand Opportunity",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "AMER CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(85, 23, 11, 70, 33, 51, true, false, false, false, false, false, false)
		},
		{
			"Leaf": "Expand Opportunity",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "EMEA CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(16, 37, 31, 75, 64, 18, true, true, true, false, false, true, true)
		},
		{
			"Leaf": "Expanded Opportunity",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "APAC CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(42, 46, 14, 34, 14, 57, true, true, false, false, false, true, true)
		},
		{
			"Leaf": "Expanded Opportunity",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "AMER CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(19, 25, 53, 93, 52, 39, true, true, true, false, false, true, false)
		},
		{
			"Leaf": "Expanded Opportunity",
			"Application": "Salesforce",
			"Stage": "Closed Won",
			"Team": "EMEA CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(79, 55, 79, 93, 89, 52, true, false, false, true, true, false, false)
		},
		{
			"Leaf": "Expand Opportunity",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "APAC CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(37, 84, 58, 26, 38, 77, true, true, true, true, true, true, false)
		},
		{
			"Leaf": "Expand Opportunity",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "AMER CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(47, 90, 44, 73, 89, 55, true, false, false, true, true, false, false)
		},
		{
			"Leaf": "Expand Opportunity",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "EMEA CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(60, 70, 78, 70, 11, 85, true, true, false, false, false, false, false)
		},
		{
			"Leaf": "Expanded Opportunity",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "APAC CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(60, 91, 38, 45, 27, 60, true, false, true, true, true, true, true)
		},
		{
			"Leaf": "Expanded Opportunity",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "AMER CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(33, 57, 57, 64, 77, 46, true, false, false, false, true, false, true)
		},
		{
			"Leaf": "Expanded Opportunity",
			"Application": "Gainsight",
			"Stage": "Closed Won",
			"Team": "EMEA CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(57, 33, 95, 10, 65, 89, true, true, true, true, true, true, false)
		},
		{
			"Leaf": "Expand Opportunity",
			"Application": "ChurnZero",
			"Stage": "Closed Won",
			"Team": "DACH CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(74, 33, 50, 62, 26, 48, true, true, true, true, false, true, false)
		},
		{
			"Leaf": "Expanded Opportunity",
			"Application": "ChurnZero",
			"Stage": "Closed Won",
			"Team": "DACH CSMs",
			"Capability": "Upsell & Expansion Strategy",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(27, 63, 12, 55, 34, 57, true, true, true, true, true, true, true)
		},
		{
			"Leaf": "Capture Lead",
			"Application": "Salesforce",
			"Stage": "Discovery",
			"Team": "EMEA BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(81, 62, 40, 77, 53, 17, true, true, false, false, false, false, false)
		},
		{
			"Leaf": "Capture Lead",
			"Application": "Salesforce",
			"Stage": "Discovery",
			"Team": "APAC BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(37, 77, 88, 22, 33, 87, true, false, false, false, true, true, true)
		},
		{
			"Leaf": "Capture Lead",
			"Application": "Salesforce",
			"Stage": "Discovery",
			"Team": "AMER BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(56, 90, 37, 82, 82, 61, true, true, true, true, false, false, true)
		},
		{
			"Leaf": "Captured Lead",
			"Application": "Salesforce",
			"Stage": "Discovery",
			"Team": "EMEA BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(46, 24, 94, 81, 88, 62, true, false, false, true, false, true, false)
		},
		{
			"Leaf": "Captured Lead",
			"Application": "Salesforce",
			"Stage": "Discovery",
			"Team": "APAC BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(19, 73, 72, 28, 60, 83, true, true, false, true, true, false, false)
		},
		{
			"Leaf": "Captured Lead",
			"Application": "Salesforce",
			"Stage": "Discovery",
			"Team": "AMER BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(24, 28, 88, 47, 47, 21, true, false, false, true, false, true, true)
		},
		{
			"Leaf": "Capture Lead",
			"Application": "Dynamics365",
			"Stage": "Discovery",
			"Team": "DACH BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(57, 52, 45, 34, 34, 42, true, false, true, false, true, false, true)
		},
		{
			"Leaf": "Captured Lead",
			"Application": "Dynamics365",
			"Stage": "Discovery",
			"Team": "DACH BDRs",
			"Capability": "Market Intelligence & Lead Generation",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(45, 93, 26, 93, 84, 45, true, true, true, false, true, true, true)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "AMER Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(45, 59, 16, 22, 74, 57, true, true, false, true, true, true, true)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "EMEA Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(74, 27, 54, 49, 59, 39, true, true, false, false, false, false, false)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "APAC Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(54, 76, 56, 72, 84, 89, true, true, true, false, false, false, true)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "AMER Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(60, 48, 40, 65, 55, 60, true, true, true, true, true, true, false)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "EMEA Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(53, 41, 38, 39, 19, 63, true, true, true, true, true, false, false)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "APAC Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(66, 80, 68, 51, 26, 27, true, true, true, false, true, false, false)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Dynamics365",
			"Stage": "Pricing",
			"Team": "DACH Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(91, 83, 63, 26, 10, 53, true, true, false, true, true, false, false)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Dynamics365",
			"Stage": "Pricing",
			"Team": "DACH Account Executives",
			"Capability": "Deal Structuring & Pricing Optimisation",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(64, 43, 93, 85, 84, 15, true, false, true, true, true, true, true)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Dynamics365",
			"Stage": "Pricing",
			"Team": "APAC Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(80, 18, 82, 41, 67, 55, true, true, true, true, true, false, true)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Dynamics365",
			"Stage": "Pricing",
			"Team": "AMER Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(36, 79, 55, 49, 90, 81, true, false, false, true, false, true, false)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Dynamics365",
			"Stage": "Pricing",
			"Team": "EMEA Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(11, 81, 35, 64, 47, 11, true, true, false, true, false, true, false)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Dynamics365",
			"Stage": "Pricing",
			"Team": "APAC Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(40, 22, 18, 14, 50, 54, true, false, false, true, true, false, false)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Dynamics365",
			"Stage": "Pricing",
			"Team": "AMER Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(16, 87, 34, 75, 30, 91, true, false, true, true, true, true, false)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Dynamics365",
			"Stage": "Pricing",
			"Team": "EMEA Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(56, 20, 93, 34, 50, 14, true, true, true, true, false, true, false)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "APAC Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(78, 35, 36, 24, 85, 76, true, false, false, false, false, true, true)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "AMER Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(95, 37, 37, 11, 31, 10, true, false, false, true, false, false, true)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "EMEA Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(30, 60, 14, 24, 69, 43, true, false, false, true, false, true, false)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "APAC Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(17, 13, 18, 46, 29, 33, true, false, true, true, false, true, false)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "AMER Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(86, 25, 35, 90, 93, 40, true, true, false, true, true, true, true)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "EMEA Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(16, 88, 18, 36, 68, 83, true, false, false, true, false, false, false)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "DACH Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(95, 37, 25, 15, 15, 22, true, true, false, false, false, false, false)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Salesforce",
			"Stage": "Pricing",
			"Team": "DACH Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(91, 55, 68, 22, 76, 77, true, false, true, true, true, false, false)
		},
		{
			"Leaf": "Validate Opportunity Solution",
			"Application": "Dynamics365",
			"Stage": "Pricing",
			"Team": "DACH Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(79, 40, 65, 12, 64, 64, true, true, true, false, true, true, false)
		},
		{
			"Leaf": "Opportunity Solution Validated",
			"Application": "Dynamics365",
			"Stage": "Pricing",
			"Team": "DACH Account Executives",
			"Capability": "ROI & Business Case Modelling",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(92, 51, 19, 49, 56, 48, true, false, true, true, false, false, true)
		},
		{
			"Leaf": "Qualify Lead",
			"Application": "Salesforce",
			"Stage": "Validation",
			"Team": "AMER Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(34, 21, 50, 40, 95, 55, true, true, false, true, false, false, true)
		},
		{
			"Leaf": "Qualify Lead",
			"Application": "Salesforce",
			"Stage": "Validation",
			"Team": "EMEA Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(53, 16, 58, 18, 57, 51, true, false, false, false, false, true, false)
		},
		{
			"Leaf": "Qualify Lead",
			"Application": "Salesforce",
			"Stage": "Validation",
			"Team": "APAC Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(29, 77, 72, 34, 56, 73, true, true, false, false, true, false, false)
		},
		{
			"Leaf": "Qualified Lead",
			"Application": "Salesforce",
			"Stage": "Validation",
			"Team": "AMER Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(19, 65, 19, 20, 94, 36, true, true, false, false, true, true, false)
		},
		{
			"Leaf": "Qualified Lead",
			"Application": "Salesforce",
			"Stage": "Validation",
			"Team": "EMEA Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model",
				"GlobusBeyond GRC"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(61, 86, 62, 81, 73, 29, true, true, false, false, true, true, false)
		},
		{
			"Leaf": "Qualified Lead",
			"Application": "Salesforce",
			"Stage": "Validation",
			"Team": "APAC Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Products": [
				"GlobusBeyond Architect",
				"GlobusBeyond Operating Model"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(25, 57, 64, 20, 93, 62, true, false, true, true, true, false, false)
		},
		{
			"Leaf": "Qualify Lead",
			"Application": "Dynamics365",
			"Stage": "Validation",
			"Team": "DACH Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Activity",
			"Percentage": new PercentageMetrics(57, 23, 37, 92, 25, 68, true, true, false, false, true, true, false)
		},
		{
			"Leaf": "Qualified Lead",
			"Application": "Dynamics365",
			"Stage": "Validation",
			"Team": "DACH Account Executives",
			"Capability": "Lead Qualification & Scoring",
			"Products": [
				"GlobusBeyond Process Miner"
			],
			"Type": "Outcome",
			"Percentage": new PercentageMetrics(87, 34, 95, 26, 91, 80, true, false, false, false, false, true, true)
		}
	]
};
